import React, { Component } from "react";

class Controls extends Component {
  render() {
    return (
      <div className="controls">
        <h3 className="is-size-4 is-capitalized">
          Cut Details for {this.props.side} Side
        </h3>

        <div className="field">
          <label className="label">Measurement</label>
          <div className="control">
            <input
              className="input"
              type="text"
              placeholder={`3' 3/16"`}
              value={this.props.measurement}
              onChange={e => {
                this.props.onChange(
                  this.props.side,
                  "measurement",
                  e.target.value
                );
              }}
            />
          </div>
        </div>
        <div className="field">
          <label className="label">Corner Type</label>
          <div className="control">
            <label className="radio">
              <input
                type="radio"
                name={`${this.props.side}_${this.props.index}_corner`}
                checked={this.props.corner === "inside"}
                onChange={e => {
                  this.props.onChange(this.props.side, "corner", "inside");
                }}
              />{" "}
              Inside
            </label>
            <label className="radio">
              <input
                type="radio"
                name={`${this.props.side}_${this.props.index}_corner`}
                checked={this.props.corner === "outside"}
                onChange={e => {
                  this.props.onChange(this.props.side, "corner", "outside");
                }}
              />{" "}
              Outside
            </label>
          </div>
        </div>

        <div className="field">
          <label className="label">Corner Side</label>
          <div className="control">
            <label className="radio">
              <input
                type="radio"
                name={`${this.props.side}_${this.props.index}_cut`}
                checked={this.props.cut === "left"}
                onChange={e => {
                  this.props.onChange(this.props.side, "cut", "left");
                }}
              />{" "}
              Left
            </label>
            <label className="radio">
              <input
                type="radio"
                name={`${this.props.side}_${this.props.index}_cut`}
                checked={this.props.cut === "right"}
                onChange={e => {
                  this.props.onChange(this.props.side, "cut", "right");
                }}
              />{" "}
              Right
            </label>
          </div>
        </div>

        <div className="field">
          <label className="label">Wall Angle&deg;</label>
          <div className="control">
            <input
              className="input"
              max={180}
              min={0}
              type="number"
              value={this.props.angle}
              onChange={e => {
                this.props.onChange(this.props.side, "angle", e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Controls;



// WEBPACK FOOTER //
// ./src/Controls.js